import {Inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

import * as moment_ from 'moment';

import {ServerResponse} from '../common/types';
import {BaseApiService, ReportingModuleConfig, IReportingModuleConfig, ApiVersionsEnum} from '../common';

import {IAccountTradesReport, IReportRequest} from '../interfaces';

const moment = moment_;
const dateFormat = 'YYYY-MM-DD';

@Injectable()
export class ReportsService extends BaseApiService {
    constructor(@Inject(ReportingModuleConfig) protected moduleConfig: IReportingModuleConfig, protected httpClient: HttpClient) {
        super(moduleConfig, httpClient);

        this.httpHeaders = this.httpHeaders.append(moduleConfig.customProtectedApiHeader, '1');
    }

    protected getApiUrl(): string {
        return this.moduleConfig.apiUrl;
    }

    private getAccountReportRequest(
        accountReferenceId: string,
        fromDate: string,
        toDate: string,
        currency?: string
    ): IReportRequest {
        return {
            accountReferenceId,
            fromDate: this.getFromDate(fromDate),
            toDate: this.getToDate(toDate),
            currency: currency
        };
    }

    private getFromDate(date: string): string {
        return moment(date)
            .utc(true)
            .startOf('day')
            .format(dateFormat);
    }

    private getToDate(date: string): string {
        return moment(date)
            .utc(true)
            .endOf('day')
            .format(dateFormat);
    }

    getAccountTradesReport(
        accountReferenceId: string,
        fromDate: string,
        toDate: string,
        currency?: string
    ): ServerResponse<IAccountTradesReport[]> {
        return this.post<IReportRequest, IAccountTradesReport[]>(
            'reports-accounts/get-trades',
            this.getAccountReportRequest(accountReferenceId, fromDate, toDate, currency),
            false, false, ApiVersionsEnum.V2
        );
    }
}
